import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMatesList } from '../../../api';

const MatesList = () => {
    const navigate = useNavigate();
    const [mates, setMates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/');
            return;
        }

        fetchMates();
    }, [navigate]);

    const fetchMates = async () => {
        try {
            setLoading(true);
            setError('');
            const data = await getMatesList();
            setMates(data || []);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch mates.');
            console.error('Error fetching mates:', err);
        } finally {
            setLoading(false);
        }
    };

    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: '#ccdff5',
            padding: '40px 20px'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                background: '#F6F6F6',
                borderRadius: '20px',
                padding: '40px',
                boxShadow: '0 4px 24px rgba(44, 62, 80, 0.08)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '30px'
                }}>
                    <h1 style={{
                        color: '#3c5a5d',
                        margin: 0,
                        fontSize: '2.5rem'
                    }}>
                        Mates List
                    </h1>
                </div>

                {error && (
                    <div style={{
                        color: '#dc2626',
                        marginBottom: '20px',
                        padding: '12px',
                        background: '#fee2e2',
                        borderRadius: '8px',
                        fontSize: '14px'
                    }}>
                        {error}
                    </div>
                )}

                {loading ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        Loading mates...
                    </div>
                ) : mates.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        No mates found.
                    </div>
                ) : (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                        gap: '24px'
                    }}>
                        {mates.map((mate, index) => (
                            <div
                                key={mate.id || mate._id || index}
                                onClick={() => navigate(`/mate-details/${mate.id || mate._id}`)}
                                style={{
                                    background: '#e5eff8',
                                    borderRadius: '16px',
                                    padding: '24px',
                                    border: '1px solid #cfd8dc',
                                    boxShadow: '0 2px 12px rgba(44, 62, 80, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 12px rgba(44, 62, 80, 0.08)';
                                }}
                            >
                                {mate.avatar_link && (
                                    <img
                                        src={mate.avatar_link}
                                        alt={mate.name}
                                        style={{
                                            width: '80px',
                                            height: '80px',
                                            objectFit: 'cover',
                                            borderRadius: '50%',
                                            marginBottom: '16px'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                )}
                                <h3 style={{
                                    color: '#3c5a5d',
                                    marginBottom: '12px',
                                    fontSize: '1.5rem',
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    {mate.name || 'Unknown Mate'}
                                    {mate.is_premium && (
                                        <span style={{
                                            fontSize: '0.8rem',
                                            background: '#fef08a',
                                            color: '#854d0e',
                                            padding: '4px 8px',
                                            borderRadius: '12px',
                                            marginLeft: '12px',
                                            fontWeight: 'bold'
                                        }}>
                                            Premium
                                        </span>
                                    )}
                                </h3>
                                <div style={{
                                    display: 'flex',
                                    gap: '8px',
                                    marginBottom: '16px',
                                    flexWrap: 'wrap'
                                }}>
                                    {mate.mate_type && (
                                        <span style={{
                                            background: '#dbeafe',
                                            color: '#1e40af',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600',
                                            textTransform: 'capitalize'
                                        }}>
                                            {mate.mate_type}
                                        </span>
                                    )}
                                    {mate.language && (
                                        <span style={{
                                            background: '#e0e7ff',
                                            color: '#3730a3',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600',
                                            textTransform: 'uppercase'
                                        }}>
                                            {mate.language}
                                        </span>
                                    )}
                                    {mate.voice && (
                                        <span style={{
                                            background: '#f3e8ff',
                                            color: '#6b21a8',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600',
                                            textTransform: 'capitalize'
                                        }}>
                                            {mate.voice} voice
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default MatesList;
